import * as React from 'react';
import { Button, Input } from '../../modules';

interface IQuantityFormProps {
  onChange: (newValue: number) => any;
  value?: number;
}

class QuantityForm extends React.PureComponent<IQuantityFormProps> {
  public render() {
    const value = this.props.value || 0;

    return (
      <form onSubmit={e => e.preventDefault()} className="form form--quantity">
        <Button onClick={() => this.props.onChange(value - 1)} type="quantity" disabled={value == 1}>
          <span className="button__minus">-</span>
        </Button>
        <span>{this.props.value || 0}</span>
        <Button onClick={() => this.props.onChange(value + 1)} type="quantity" disabled={false}>
          <span className="button__plus">+</span>
        </Button>
      </form>
    );
  }
}

export default QuantityForm;



// WEBPACK FOOTER //
// ./src/modules/Form/Quantity/index.tsx